import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

export interface EndgoodVariant {
  id: number;
  color: string;
  sku: string;
  endgood: {
    id: number;
    itemName: string;
    sku: string;
  };
}

export interface EndgoodVariantCreateRequest {
  color: string;
  endgoodId: number;
}

class EndgoodVariantApiService extends BaseApiService {
  // Create multiple color variants for an endgood
  async createMultipleVariantsForEndgood(endgoodId: number, colors: string[]): Promise<EndgoodVariant[]> {
    try {
      const response = await this.makeRequest<ApiResponse<EndgoodVariant[]>>(
        API_ENDPOINTS.ENDGOOD_VARIANTS.CREATE_MULTIPLE(endgoodId.toString()),
        {
          method: HTTP_METHODS.POST,
          body: JSON.stringify(colors),
        }
      );
      if (response.success) {
        toast.success(`${colors.length} color variants created successfully`);
        return response.data;
      }
      throw new Error(response.message || 'Failed to create variants');
    } catch (error) {
      toast.error('Failed to create color variants');
      throw error;
    }
  }

  // Get variants for a specific endgood
  async getVariantsByEndgoodId(endgoodId: number): Promise<EndgoodVariant[]> {
    try {
      const response = await this.makeRequest<ApiResponse<EndgoodVariant[]>>(
        API_ENDPOINTS.ENDGOOD_VARIANTS.GET_BY_ENDGOOD(endgoodId.toString()),
        {
          method: HTTP_METHODS.GET,
        }
      );
      if (response.success) {
        return response.data;
      } else {
        throw new Error(response.message || 'Failed to fetch variants');
      }
    } catch (error) {
      // console.error('Error fetching variants:', error);
      toast.error('Failed to fetch endgood variants');
      throw error;
    }
  }

  // Delete all variants for a specific endgood
  async deleteVariantsByEndgoodId(endgoodId: number): Promise<void> {
    try {
      const response = await this.makeRequest<ApiResponse<void>>(
        API_ENDPOINTS.ENDGOOD_VARIANTS.DELETE_BY_ENDGOOD(endgoodId.toString()),
        {
          method: HTTP_METHODS.DELETE,
        }
      );
      if (response.success) {
        toast.success('Endgood variants deleted successfully');
      } else {
        throw new Error(response.message || 'Failed to delete variants');
      }
    } catch (error) {
      // console.error('Error deleting variants:', error);
      toast.error('Failed to delete endgood variants');
      throw error;
    }
  }
}

export const endgoodVariantApiService = new EndgoodVariantApiService();
